import styled from 'styled-components';
import { buildStyledComponent } from 'decisiv-ui-utils';

const styles = `
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
`;

export default buildStyledComponent(
  'LoginPageWrapper',
  styled.section,
  styles,
  {
    className: 'LoginPage',
  },
);



// WEBPACK FOOTER //
// ./features/authentication/LoginPage/Wrapper.js